import type React from "react";
import { useTranslation } from "react-i18next";
import type { BriefDetails } from "src/model/model";

interface TextDetailsProps {
  data: BriefDetails | Record<string, unknown>;
  mode: "plan" | "recap";
}

const ns = "pages.chat.interactionDetails";

const TextDetails: React.FC<TextDetailsProps> = ({ data, mode }) => {
  const { t } = useTranslation();
  if (!data) return null;

  if (mode === "plan") {
    const bd = data as BriefDetails;
    if (!bd.expectedKeyPoints?.length && !bd.expectedTone) return null;
    return (
      <div className="space-y-1 text-[11px] text-gray-700">
        {bd.expectedTone && (
          <div>
            <span className="font-medium text-gray-500">{t(`${ns}.tone`)} : </span>
            {bd.expectedTone}
          </div>
        )}
        {bd.expectedKeyPoints && bd.expectedKeyPoints.length > 0 && (
          <div>
            <span className="font-medium text-gray-500">{t(`${ns}.keyPoints`)} :</span>
            <ul className="ml-3 mt-0.5 list-disc list-inside">
              {bd.expectedKeyPoints.map((kp, i) => (
                <li key={i}>{kp}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }

  const d = data as Record<string, unknown>;
  const text = typeof d.text === "string" ? d.text : "";
  if (!text) return null;
  return (
    <div className="text-[11px] text-gray-700 whitespace-pre-wrap bg-gray-50 rounded p-2">
      {text}
    </div>
  );
};

export default TextDetails;
